import React, { useState, useEffect, useCallback } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import BasicModalContainer from '../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../common/components/basicmodal/ModalFooter';
import { searchAddress } from '../../../api/AllAddress ';

import { addressModalStyle } from './AddressModalStyle';
import Autocomplete from '@mui/material/Autocomplete';
import { Platform } from 'react-native';
import { TextField } from '@mui/material';
import { getAddressLabel } from '../../../common/utils/Helpers';

interface CommunicationModalProps {
  isModalVisible: boolean;
  closeModal: () => void;
  onSave: (location?: { id: number; address: string }) => void;
  initialValue?: any;
}

const AddressModal = ({
  isModalVisible,
  closeModal,
  onSave,
  initialValue,
}: CommunicationModalProps) => {
  const [searchedAddresses, setSearchedAddresses] = useState<Array<any>>([]);
  const [selectedAddress, selectAddress] = useState(null);
  const [searchKey, setSearchKey] = useState('');

  const getAddresses = useCallback(
    async (q: any) => {
      setSearchKey(q);
      selectAddress(null);
      const filterToken = q.toLowerCase();
      const response = await searchAddress(filterToken, initialValue.brand_id);
      const items = await response.json();
      if (Array.isArray(items)) {
        setSearchedAddresses(
          items.map((address, index) => {
            let addressOption = {
              ...address,
              label: getAddressLabel(address, index)
            };
            return addressOption;
          })
        );
      } else {
        setSearchedAddresses([]);
      }
    },
    [initialValue]
  );

  const handleSave = () => {
    // Include location data in the send operation if needed
    onSave(selectedAddress);
    closeModal();
  };

  const closeModalHandler = () => {
    closeModal();
  };

  return isModalVisible ? (
    <View style={{ position: 'absolute', width: '100%', height: '100%' }}>
      <BasicModalContainer>
        <ModalHeader label={'Select Address'} closeModal={closeModalHandler} />
        <ModalBody style={{ zIndex: 10 }}>
          <View style={[{ width: '100%', minWidth: 450 }]}>
            {Platform.OS === 'web' ? (
              <>
                <Text style={{ marginBottom: 6, color: '#555555' }}>{'Delivery Address'}</Text>
                <Autocomplete
                  // Multiple={true}
                  freeSolo
                  sx={{
                    width: '100%',
                    padding: '0px',
                    borderRadius: '0px',
                  }}
                  disableClearable
                  options={searchedAddresses}
                  value={selectedAddress}
                  inputValue={searchKey}
                  onChange={(event, value) => {
                    selectAddress(value);
                  }}
                  onInputChange={(event, value) => {
                    getAddresses(value);
                  }}
                  onClose={(event: React.SyntheticEvent, reason: string) => {}}
                  filterOptions={(x) => {
                    return x;
                  }}
                  renderInput={(params) => {
                    const text = String(params?.inputProps?.value ?? ' ');
                    const spanIndex = text.indexOf('<span');
                    const inputVal = spanIndex !== -1 ? text.substring(0, spanIndex) : text;
                    return (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          type: 'search',
                          value: inputVal,
                          style: {
                            padding: '2px',
                            fontSize: '14px',
                          },
                        }}
                      />
                    );
                  }}
                  renderOption={(props, option) => {
                    const htmlLabel = { __html: option.label };
                    return (
                      <li {...props}>
                        <span style={{ fontSize: '14px' }} dangerouslySetInnerHTML={htmlLabel} />
                      </li>
                    );
                  }}
                />
              </>
            ): ""}
          </View>
        </ModalBody>
        <ModalFooter>
          <View style={styles.footerContainer}>
            <TouchableOpacity onPress={closeModalHandler}>
              <Text style={styles.addButton}>Cancel</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handleSave}>
              <Text style={styles.addButton}>Save</Text>
            </TouchableOpacity>
          </View>
        </ModalFooter>
      </BasicModalContainer>
    </View>
  ) : null;
};

const styles = addressModalStyle;

export default AddressModal;
